export const Success=()=>{
    return (
        <div>
            <img src = "https://www.statistika.co/images/Payment/Success%201000x468.jpg"/>
        </div>
    )
}